import usePayment from 'data/hooks/usePayment';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import { today } from 'components/Form/WeekRangePicker/utils';
import { useEffect, useState } from 'react';
import { HoverRange } from 'data/types/hoverRange';
import { Props } from './types';

const useConnect = ({ brandId }: Props) => {
  const { payment, isLoading, refetch } = usePayment(brandId);
  const [modalContent, setModalContent] = useState<any>();

  useEffect(() => {
    if (brandId !== '') {
      refetch();
    }
  }, [refetch, brandId]);
  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(getWeekDays(today));
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };

  return {
    payment,
    isLoading,
    setModalContent,
    modalContent,
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
  };
};

export default useConnect;
